import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import withValidation from '../withValidation';
import styles from './styles.scss';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';


class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onChange = this.onChange.bind(this);
  }

  get options() {
    return this.props.options.map((option) => ({
      value: option.value || option,
      label: option.label || option
    }));
  }

  static getDerivedStateFromProps({options, value}) {
    return {
      selectedOption: options.find(option => (option === value)
        || (option.value === value) || (option && option.value && option.value.id && value.id && option.value.id === value.id))
    }
  }

  onChange(selectedOption) {
    const { onChange } = this.props;
    this.setState(
      { selectedOption },
      () => onChange && onChange(selectedOption.value)
    )
  }

  render() {
    const {
      error,
      invalid,
      isLoading,
      disabled
    } = this.props;
    const { selectedOption } = this.state;
    const style = disabled ? styles.disabled : styles.select;
    return [
      <ReactSelect
        key='select'
        className={classNames(style, {
          [styles.invalid]: invalid
        })}
        placeholder='Choose...'
        isLoading={isLoading}
        disabled={disabled}
        searchable={false}
        clearable={false}
        multi={false}
        value={selectedOption}
        onChange={this.onChange}
        options={this.options}
      />,
      <If condition={invalid} key='error'>
        <span className={styles.error}>{error}</span>
      </If>
    ];
  }
}

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Select.defaultValues = {
  options: []
};

export default withValidation(Select);


// WEBPACK FOOTER //
// src/components/shared/Select/index.jsx